window.umamiSpaMode = true; // Set to true to use hash for tracking instead of pathname.

function loadUmami(websiteId, tag = '', spaMode = true) {
    window.umamiSpaMode = spaMode;

    if (window.umami) {
        // If umami is already loaded, resolve immediately.
        console.log('Umami already loaded');
        return Promise.resolve(window.umami);
    }

    console.log('Loading Umami script', websiteId, tag);
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://umi.deleted.io/script.js';
        script.defer = true;
        script.setAttribute('data-website-id', websiteId);
        script.setAttribute('data-auto-track', 'false');
        script.setAttribute('data-tag', tag || '');
        script.onload = () => resolve(window.umami);
        script.onerror = () => reject(new Error('Script load error'));
        document.head.appendChild(script);
    });
}

function getCurrentUrl() {
    if (window.umamiSpaMode) {
        return window.location.hash.replace(/^#/, '') || '/';
    }

    return window.location.pathname + window.location.search;
}

function defaultTrackProps() {
    return {
        userAgent: navigator.userAgent,
        url: getCurrentUrl(),
    };
}

function trackCurrentPage() {
    if (window.umami) {
        window.umami.track((props) => ({
            ...props,
            ...defaultTrackProps(),
        }));
    }
}

function trackEvent(name, data = {}) {
    if (window.umami) {
        window.umami.track((props) => ({
            ...props,
            ...defaultTrackProps(),
            name,
            data,
        }));
    }
}

const UMAMI_EVENTS = {
    REMOTE_APP_LOADED: 'remote-app-loaded',

    // Home page

    OPEN_LOGIN_BROWSER: 'open-login-browser',

    EXIT_LOGIN_BROWSER: 'exit-login-browser',

    LOGGED_IN: 'logged-in',

    // Sync page

    START_SYNC: 'start-sync',

    SYNC_AGAIN: 'sync-again',

    RETRY_SYNC: 'retry-sync',

    SYNC_COMPLETE: 'sync-complete',

    SYNC_FAILED: 'sync-failed',

    // Settings page

    DEV_MODE_ENABLED: 'dev-mode-enabled',
};

module.exports = {
    loadUmami,
    getCurrentUrl,
    trackCurrentPage,
    trackEvent,
    UMAMI_EVENTS,
};
